var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1668 9.9043H3.34277C2.92877 9.9043 2.59277 9.5683 2.59277 9.1543C2.59277 8.7403 2.92877 8.4043 3.34277 8.4043H21.1668C21.5808 8.4043 21.9168 8.7403 21.9168 9.1543C21.9168 9.5683 21.5808 9.9043 21.1668 9.9043Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7013 13.8105C16.2873 13.8105 15.9473 13.4745 15.9473 13.0605C15.9473 12.6465 16.2783 12.3105 16.6923 12.3105H16.7013C17.1153 12.3105 17.4513 12.6465 17.4513 13.0605C17.4513 13.4745 17.1153 13.8105 16.7013 13.8105Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2638 13.8105C11.8498 13.8105 11.5098 13.4745 11.5098 13.0605C11.5098 12.6465 11.8408 12.3105 12.2548 12.3105H12.2638C12.6778 12.3105 13.0138 12.6465 13.0138 13.0605C13.0138 13.4745 12.6778 13.8105 12.2638 13.8105Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81652 13.8105C7.40252 13.8105 7.06152 13.4745 7.06152 13.0605C7.06152 12.6465 7.39352 12.3105 7.80752 12.3105H7.81652C8.23052 12.3105 8.56652 12.6465 8.56652 13.0605C8.56652 13.4745 8.23052 13.8105 7.81652 13.8105Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7013 17.6973C16.2873 17.6973 15.9473 17.3613 15.9473 16.9473C15.9473 16.5333 16.2783 16.1973 16.6923 16.1973H16.7013C17.1153 16.1973 17.4513 16.5333 17.4513 16.9473C17.4513 17.3613 17.1153 17.6973 16.7013 17.6973Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2638 17.6973C11.8498 17.6973 11.5098 17.3613 11.5098 16.9473C11.5098 16.5333 11.8408 16.1973 12.2548 16.1973H12.2638C12.6778 16.1973 13.0138 16.5333 13.0138 16.9473C13.0138 17.3613 12.6778 17.6973 12.2638 17.6973Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81652 17.6973C7.40252 17.6973 7.06152 17.3613 7.06152 16.9473C7.06152 16.5333 7.39352 16.1973 7.80752 16.1973H7.81652C8.23052 16.1973 8.56652 16.5333 8.56652 16.9473C8.56652 17.3613 8.23052 17.6973 7.81652 17.6973Z",
    fill: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2939 5.791C15.8799 5.791 15.5439 5.455 15.5439 5.041V1.75C15.5439 1.336 15.8799 1 16.2939 1C16.7079 1 17.0439 1.336 17.0439 1.75V5.041C17.0439 5.455 16.7079 5.791 16.2939 5.791Z",
    fill: "current"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21484 5.791C7.80084 5.791 7.46484 5.455 7.46484 5.041V1.75C7.46484 1.336 7.80084 1 8.21484 1C8.62884 1 8.96484 1.336 8.96484 1.75V5.041C8.96484 5.455 8.62884 5.791 8.21484 5.791Z",
    fill: "current"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7908_10079",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 21
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 2.57812H22V22.499H2.5V2.57812Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7908_10079)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.021 4.07812C5.428 4.07812 4 5.46113 4 7.97213V17.0211C4 19.5871 5.428 20.9991 8.021 20.9991H16.479C19.072 20.9991 20.5 19.6131 20.5 17.0971V7.97213C20.504 6.73712 20.172 5.77713 19.513 5.11713C18.835 4.43712 17.79 4.07812 16.488 4.07812H8.021ZM16.479 22.4991H8.021C4.616 22.4991 2.5 20.4001 2.5 17.0211V7.97213C2.5 4.64412 4.616 2.57812 8.021 2.57812H16.488C18.197 2.57812 19.61 3.09012 20.575 4.05712C21.512 4.99813 22.005 6.35112 22 7.97412V17.0971C22 20.4291 19.884 22.4991 16.479 22.4991Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.947d1c8c.svg";
export { ForwardRef as ReactComponent };